export default async function getLeftMenuData() {
  return [
    {
      title: 'New Quote',
      key: 'newquote',
      icon: 'icmn icmn-quotes-left',
      url: '/account/newquote',
      hide: false,
    },
    {
      title: 'Qualify and Snapshot',
      key: 'instants',
      icon: 'icmn icmn-sphere',
      children: [
        {
          key: 'instantsMyStudies',
          title: 'My Studies',
          url: '/account/instants',
        },
        {
          key: 'instantsMyQuotes',
          title: 'My Quotes',
          url: '/account/instants/myquotes',
        },
      ],
    },
    {
      title: 'Aura',
      key: 'via',
      icon: 'icmn icmn-earth',
      children: [
        {
          key: 'viaMyStudies',
          title: 'My Studies',
          url: '/account/aura',
        },
      ],
    },
    // {
    //   title: 'Veriglif',
    //   key: 'veriglif',
    //   icon: 'icmn icmn-database',
    //   children: [
    //     {
    //       key: 'veriglifDashboard',
    //       title: 'Dashboard',
    //       url: '/account/veriglif',
    //     },
    //     {
    //       key: 'veriglifNewStudy',
    //       title: 'New Study',
    //       url: '/account/veriglif/newstudy',
    //     },
    //     {
    //       key: 'veriglifConnect',
    //       title: 'Connect',
    //       url: '/account/veriglif/connect',
    //     },
    //   ],
    // },
    {
      title: 'Analytics',
      key: 'analytcs',
      icon: 'icmn icmn-stats-dots',
      children: [
        {
          key: 'myQuotes',
          title: 'My Quotes',
          url: '/account/analytics/myquotes',
        },
      ],
    },
    {
      title: 'Admin',
      key: 'admin',
      icon: 'icmn icmn-lock',
      children: [
        {
          title: 'General Platform',
          key: 'groupGeneral',
          children: [
            {
              key: 'adminApprovals',
              title: 'Approvals',
              url: '/admin/approvals',
              requiredPrivilege: 'approvals',
            },
            {
              key: 'adminAddUser',
              title: 'Add user',
              url: '/admin/adduser',
              requiredPrivilege: 'addUser',
            },
            {
              key: 'adminDeleteUser',
              title: 'Delete user',
              url: '/admin/deleteuser',
              requiredPrivilege: 'deleteUser',
            },
            {
              key: 'adminCleanup',
              title: 'Data cleanup',
              url: '/admin/cleanup',
              requiredPrivilege: 'cleanup',
            },
          ],
        },
        {
          title: 'Study & Project Management',
          key: 'groupStudy',
          children: [
            {
              key: 'assignStudy',
              title: 'Assign study',
              url: '/admin/assignstudy',
              requiredPrivilege: 'assignStudy',
            },
            {
              key: 'resetStudyStats',
              title: 'Reset study stats',
              url: '/admin/resetstudystats',
              requiredPrivilege: 'resetStudyStats',
            },
            {
              key: 'removeUser',
              title: 'Remove study user',
              url: '/admin/removeuser',
              requiredPrivilege: 'removeStudyUser',
            },
            {
              key: 'studyTracker',
              title: 'Study tracker',
              url: '/admin/studytracker',
              requiredPrivilege: 'studyTracker',
            },
          ],
        },
        {
          title: 'Aura Specific',
          key: 'groupAura',
          children: [
            {
              key: 'adminMissionConfig',
              title: 'Aura mission config',
              url: '/admin/missionconfig',
              requiredPrivilege: 'viaMissionConfig',
            },
            {
              key: 'adminStudyConfig',
              title: 'Aura study config',
              url: '/admin/studyconfig',
              requiredPrivilege: 'viaStudyConfig',
            },
            {
              title: 'Test data',
              key: 'testdata',
              url: '/admin/testdata',
              requiredPrivilege: 'testData',
            },
          ],
        },
      ],
    },
    {
      title: 'Demo',
      key: 'demo',
      icon: 'icmn icmn-sphere',
      children: [
        {
          key: 'demoProduct',
          title: 'Product',
          url: '/account/demo/product',
        },
        {
          key: 'demoCaseStudies',
          title: 'Case Studies',
          url: '/account/demo/casestudies',
        },
      ],
    },
    {
      title: 'Doc Hub',
      key: 'dochub',
      icon: 'icmn icmn-files-empty',
      url: '/account/dochub',
      hide: false,
    },
  ]
}
